import { token } from '@atlaskit/tokens';
import styled from 'styled-components';

const FieldNameContainer = styled.span`
  &,
  span {
    display: inline-flex;
    align-items: center;
  }

  > :nth-child(2) {
    margin-left: ${token('space.100', '8px')};
  }
`;

export default FieldNameContainer;
